export const elementWidth = 300;
export const partHeight = 100;
export const hooksRectWidth = 1150;
export const hooksRectHeight = 750;
